import React, { Component } from "react";
import { Box, Typography, Button } from "@mui/material";

interface Props {
	children: React.ReactNode;
}

interface State {
	hasError: boolean;
	error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
	state: State = { hasError: false, error: null };

	static getDerivedStateFromError(error: Error): State {
		return { hasError: true, error };
	}

	render() {
		if (this.state.hasError) {
			return (
				<Box sx={{ p: 4, textAlign: "center" }}>
					<Typography variant="h5" fontWeight={600} gutterBottom>
						Algo deu errado
					</Typography>
					<Typography variant="body1" color="text.secondary" mb={3}>
						{this.state.error?.message || "Erro inesperado na aplicacao."}
					</Typography>
					<Button
						variant="contained"
						onClick={() => window.location.reload()}
						sx={{ bgcolor: "#59e60d", "&:hover": { bgcolor: "#48c307" } }}
					>
						Recarregar
					</Button>
				</Box>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
